import {Col, Image, Row} from "react-bootstrap";
import './Logo.css';
import {useContext} from "react";
import {CustomThemeContext} from "../../Context/ThemeContext";

export const LoginLogo = () => {

    const {theme} = useContext(CustomThemeContext);

    return <Row className="text-center">
        <Col className="col-sm-6 offset-md-3">
            <Image
                className="col-6 logo-img"
                src={'data:image/png;base64,' + theme.headerLogo}
                title={theme.siteName} alt="Logo"/>
        </Col>
    </Row>
}
